import { UserInfo, StreamsResponse } from './types';

const API_BASE = '/api';

export async function getUserInfo(): Promise<UserInfo> {
  const response = await fetch(`${API_BASE}/user/me`, {
    credentials: 'include',
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch user info');
  }
  
  return response.json();
}

export async function getLiveStreams(): Promise<StreamsResponse> {
  const response = await fetch(`${API_BASE}/streams/live`, {
    credentials: 'include',
  });
  
  if (!response.ok) {
    if (response.status === 401) {
      throw new Error('Unauthorized');
    }
    throw new Error('Failed to fetch streams');
  }
  
  return response.json();
}

export async function logout(): Promise<void> {
  const response = await fetch(`${API_BASE}/auth/logout`, {
    method: 'POST',
    credentials: 'include',
  });
  
  if (!response.ok) {
    throw new Error('Failed to logout');
  }
}

export function loginWithTwitch(): void {
  window.location.href = `${API_BASE}/auth/twitch/login`;
}

export function loginWithYouTube(): void {
  window.location.href = `${API_BASE}/auth/youtube/login`;
}
